import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBNavbarLink,
} from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";
import Specialities from "../img/specialities/cardiology.jpg";
import Pediatrics from "../img/specialities/pediatrics.jpg";
import Neurology from "../img/specialities/neurology.jpg";
import Dermatology from "../img/specialities/dermatology.jpg";
import InternalMedicine from "../img/specialities/internal medicine.jpg";
// import psychology from "../img/specialities/psychology.jpg";
import ContactModal from "../modals/modal_contact";
// import ContactModal1 from "../modals/modal_contact";
import plasticsurgery from "../img/specialities/plastic surgery.jpg";
import surgery from "../img/specialities/general surgery.jpg";
import rheumtology from "../img/specialities/rheumatology.jpg";
import infectious from "../img/specialities/infectious disease.jpg";
import gynacology from "../img/specialities/gynaecology.jpg";
import Urology from "../img/specialities/urology.jpg";
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
ReactGA.initialize('G-7WQFXCQFVP');
const Medicalbillingsys = () => {
const location = useLocation();
 
useEffect(() => {
  if (!location.hash) return;
 
  // remove the '#' from hash
  const id = location.hash.replace('#', '');
  const tryScroll = () => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      // Try again shortly (if content not mounted yet)
      setTimeout(tryScroll, 150);
    }
  };
 
  tryScroll();
}, [location]);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
  }, []);

  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const handleCloseModal = () => {
    setBasicModal(false);
  };

  const [basicModal1, setBasicModal1] = useState(false);
  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const handleCloseModal1 = () => {
    setBasicModal1(false);
  };

  const [basicModal2, setBasicModal2] = useState(false);
  const toggleShow2 = () => setBasicModal2(!basicModal2);
  const handleCloseModal2 = () => {
    setBasicModal2(false);
  };

  const [basicModal3, setBasicModal3] = useState(false);
  const toggleShow3 = () => setBasicModal3(!basicModal3);
  const handleCloseModal3 = () => {
    setBasicModal3(false);
  };

  const [basicModal4, setBasicModal4] = useState(false);
  const toggleShow4 = () => setBasicModal4(!basicModal4);
  const handleCloseModal4 = () => {
    setBasicModal4(false);
  };

  const [basicModal5, setBasicModal5] = useState(false);
  const toggleShow5 = () => setBasicModal5(!basicModal5);
  const handleCloseModal5 = () => {
    setBasicModal5(false);
  };
  const [basicModal6, setBasicModal6] = useState(false);
  const toggleShow6 = () => setBasicModal6(!basicModal6);
  const handleCloseModal6 = () => {
    setBasicModal6(false);
  };
  const [basicModal7, setBasicModal7] = useState(false);
  const toggleShow7 = () => setBasicModal7(!basicModal7);
  const handleCloseModal7 = () => {
    setBasicModal7(false);
  };
  const [basicModal8, setBasicModal8] = useState(false);
  const toggleShow8 = () => setBasicModal8(!basicModal8);
  const handleCloseModal8 = () => {
    setBasicModal8(false);
  };
  const [basicModal9, setBasicModal9] = useState(false);
  const toggleShow9 = () => setBasicModal9(!basicModal9);
  const handleCloseModal9 = () => {
    setBasicModal5(false);
  };
  const [basicModal10, setBasicModal10] = useState(false);
  const toggleShow10 = () => setBasicModal10(!basicModal10);
  const handleCloseModal10 = () => {
    setBasicModal10(false);
  };
  const [basicModal11, setBasicModal11] = useState(false);
  const toggleShow11 = () => setBasicModal11(!basicModal11);
  const handleCloseModal11 = () => {
    setBasicModal11(false);
  };
  return (
    <>
      <Helmet>
        <title> Cardiology Practices We Support | AcerHealth </title>
        <link rel="canonical" href="https://acerhealth.com/Cardologyspeciality" />
        <meta name="description" content="AcerHealth supports cardiology practices with tailored medical billing, accurate coding, and efficient revenue cycle solutions to boost practice performance." />
      </Helmet>
      <MDBContainer fluid className="p-0 bg-light">
        <div className="container py-5">

          <div className="row">
            <div className="col-12"
            // style={{ backgroundColor: 'whitesmoke' }}
            >
              <div className="section-title mb-4 pb-2">
                <h1
                  className="title mb-4 mt-4 display-heading AcerhealthTextPurple text-center fomtsizetest"
                  style={{ fontFamily: 'Lora, serif' }}
                >
                  Our Network of Medical Specialists
                </h1>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">

                <div class="col-md-4 text-center mt-4">
                  <img
                    src={Specialities}
                    className="img-fluid"
                    alt="Specialities"
                    width={350}
                    height={250}
                  />
                </div>
                <div id="Cardology_speciality" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Cardiology and Interventional Cardiology
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px', textAlign: "justify" }}
                  >
                    At AcerHealth, we provide specialized
                    <a
                      href="https://www.acerhealth.com/services/medical-billing-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                      medical billing services
                    </a> medical billing services for cardiology and interventional cardiology practices of all sizes.
                    Our certified billing experts focus on accuracy, speed, and full compliance to help reduce your<b> denial rate </b>and improve cash flow.
                    As a leading <b>medical coding and billing company,</b> we offer end-to-end solutions that enhance your revenue cycle management.
                    From detailed charge entry to
                    <a
                      href="https://acerhealth.com/services/denial-management-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                      healthcare denial management
                    </a>  and regular <b>billing audits,</b> our services are tailored to meet the
                    unique needs of cardiovascular care. Trust AcerHealth for reliable, scalable, and efficient billing support that keeps your practice thriving.
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow2}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal2}
                      onClose={handleCloseModal2}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div id="Pediatrics" class="col-md-8" style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Pediatrics
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px', textAlign: "justify" }}
                  >
                    At AcerHealth, we offer specialized <b>medical billing services</b> for pediatric practices, helping providers stay fully compliant with complex pediatric billing standards.
                    Our expert team understands the unique coding requirements and reimbursement challenges involved in pediatric care, from well-child visits to immunizations and
                    chronic condition management. As a trusted <b>medical coding and billing company,</b> we streamline your
                    <a
                      href="https://www.acerhealth.com/services/medical-billing-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                      revenue cycle management
                    </a> , reduce billing errors, and improve
                    overall claim acceptance rates.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px', textAlign: "justify" }}
                  >
                    Our pediatric billing solutions include <b>medical billing compliance services,</b> real-time eligibility checks, denial tracking,
                    and customized reporting to give your practice complete financial visibility. We also support <b>healthcare denial management </b>
                    and ensure prompt claim resubmissions, helping you minimize revenue leakage and focus more on delivering quality care to children.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px', textAlign: "justify" }}
                  >
                    Whether you're a solo pediatrician or part of a larger group, AcerHealth is your partner in efficient, accurate, and compliant pediatric billing.</p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow1}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal1}
                      onClose={handleCloseModal1}
                    />
                  </span>
                </div>
                <div class="col-md-4 text-center ">
                  <img
                    src={Pediatrics}
                    alt="Pediatrics"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">
                <div class="col-md-4 text-center mt-4">
                  <img
                    src={Neurology}
                    alt="Neurology"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
                <div id="Psychiatry" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Psychiatry
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                    At AcerHealth, our specialized <b>psychiatry medical billing services</b> are designed to maximize your revenue and streamline daily operations, 
                    allowing mental health professionals to focus more on patient care. We understand the unique challenges of psychiatry billing,
                     from time-based coding to complex insurance authorizations. As a leading 
                     <a
                      href="https://acerhealth.com/services/medical-coding-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                     medical coding and billing company
                    </a>, AcerHealth ensures 
                     accurate documentation, faster reimbursements, and full regulatory compliance.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px', textAlign:"justify" }}
                  >
                    Our solutions support every step of your <b>revenue cycle management</b>—from patient eligibility checks and claim submissions to <b>healthcare denial 
                    management </b>and timely follow-ups. We also provide tailored <b>medical billing compliance services</b> to reduce risks and ensure proper coding
                     for behavioral health services.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                    By partnering with AcerHealth, psychiatrists and mental health providers gain access to a trusted team that helps improve cash flow, 
                    reduce claim denials, and maintain a strong financial foundation. Focus on healing minds—let us handle your billing with precision and care. </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow2}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal2}
                      onClose={handleCloseModal2}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div id="Dermatology" class="col-md-8" style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Dermatology
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                    <b>Dermatology practices face unique billing challenges, and AcerHealth is here to simplify them.</b> We provide tailored <b>medical billing services </b>
                    that enhance your operational efficiency and increase revenue. Our experienced billing experts understand dermatology-specific codes and 
                    payer guidelines, ensuring accurate claims and faster reimbursements.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                    As a trusted 
                    <a
                      href="https://acerhealth.com/services/medical-coding-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                     medical coding and billing company
                    </a>
                    , we deliver end-to-end <b>revenue cycle management,</b> including eligibility checks, claim submissions, 
                   <b> healthcare denial management,</b> and reporting. Our 
                   <a
                      href="https://acerhealth.com/services/contract-compliance"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                  medical billing compliance services
                    </a> also help you maintain full regulatory adherence.
                  </p>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                    Partner with AcerHealth to streamline your dermatology billing and achieve long-term financial health.
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow3}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal3}
                      onClose={handleCloseModal3}
                    />
                  </span>
                </div>
                <div class="col-md-4 text-center ">
                  <img
                    src={Dermatology}
                    alt="Dermatology"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">
                <div class="col-md-4 text-center mt-4">
                  <img
                    src={InternalMedicine}
                    alt="InternalMedicine"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
                <div id="Internal_Medicine" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Internal Medicine
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                   Internal medicine practices manage a wide range of complex cases—and accurate billing is critical to maintaining financial health. At AcerHealth, 
                   we provide specialized <b>medical billing services </b>designed for internal medicine providers who need efficiency, accuracy, and compliance.
                    Our expert team helps reduce administrative burdens so your practice can focus more on patient care and less on paperwork.
                  </p>
                   <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                   As a leading <b>medical coding and billing company</b>, we offer complete <b>revenue cycle management,</b> including insurance verification, charge capture,
                    claim submission, and <b>healthcare denial management.</b> With our proactive approach, we help minimize billing errors, accelerate reimbursements,
                     and support your practice with reliable <b>medical billing compliance services.</b>
                  </p>
                   <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                  From chronic care to diagnostic services, AcerHealth ensures every procedure is coded correctly and reimbursed promptly. 
                  Trust our internal medicine billing experts to streamline your operations, boost revenue, and keep your practice running efficiently.
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow4}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal4}
                      onClose={handleCloseModal4}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">
                <div id="Plastic_Surgery" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Plastic Surgery
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                    Plastic surgery billing involves detailed documentation, accurate coding, and timely preauthorizations. At AcerHealth, we specialize in <b>medical billing 
                    services </b>for plastic surgeons, ensuring seamless insurance coordination and faster reimbursements. Our team handles everything from verifying eligibility
                     to managing <b>healthcare denial management</b> and responding to frequent medical record requests.  </p>
                       <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                  As a reliable 
                   <a
                      href="https://acerhealth.com/services/medical-coding-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                     medical coding and billing company
                    </a> we streamline your <b>revenue cycle management </b>while ensuring full <b>medical billing compliance.</b> Whether it’s cosmetic or reconstructive procedures, 
                  AcerHealth helps reduce delays, prevent denials, and maintain strong cash flow—so you can focus on delivering outstanding care.  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow6}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal6}
                      onClose={handleCloseModal6}
                    />
                  </span>
                </div>
                <div class="col-md-4 text-center mt-4">
                  <img
                    src={plasticsurgery}
                    alt="plasticsurgery"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img
                    src={surgery}
                    alt="surgery"
                    className="img-fluid"
                    width={350}
                    height={500}
                  />
                </div>
                <div id="Surgery" class="col-md-8" style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Surgery
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                  AcerHealth offers specialized <b>medical billing services </b>for surgical practices, streamlining complex billing processes and reducing administrative burdens.
                   Our expert team ensures accurate coding, efficient claim submissions, and proactive <b>healthcare denial management</b> to minimize revenue loss. 
                   As a trusted 
                    <a
                      href="https://acerhealth.com/services/medical-coding-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                     medical coding and billing company
                    </a>, we help surgeons maintain compliance while improving their <b>revenue cycle management.</b>
                    From preoperative authorizations to post-op billing, we handle every detail so providers can focus on delivering quality surgical care. 
                    With AcerHealth, your practice benefits from faster reimbursements, fewer billing errors, and stronger financial performance—all while enhancing patient care.    </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow7}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal7}
                      onClose={handleCloseModal7}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">
                <div id="Rheumatology" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Rheumatology
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px' ,textAlign:"justify"}}
                  >
                   Rheumatology billing requires precise documentation, accurate coding, and timely preauthorization due to complex, ongoing treatments. 
                   At AcerHealth, we specialize in 
                   <a
                      href="https://acerhealth.com/services/medical-billing-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                  medical billing services
                    </a> for rheumatologists, ensuring all procedures are properly documented and
                    preapproved by insurance providers. Our team handles insurance verification, <b>healthcare denial management,</b> and frequent medical 
                    record requests to support clean claim submissions and prompt reimbursements. As a leading <b>medical coding and billing company, </b>
                    we streamline your
                    <a
                      href="https://acerhealth.com/services/revenue-cycle-management"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                 revenue cycle management
                    </a>  and reduce administrative burdens. With AcerHealth, your rheumatology practice benefits 
                    from improved compliance, steady cash flow, and more time to focus on patient care.   </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow8}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal8}
                      onClose={handleCloseModal8}
                    />
                  </span>
                </div>
                <div class="col-md-4 text-center mt-4">
                  <img
                    src={rheumtology}
                    alt="rheumtology"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img
                    src={infectious}
                    alt="infectious"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
                <div id="Infection_Diseases" class="col-md-8" style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Infection Diseases
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                  At AcerHealth, we provide specialized <b>medical billing services</b> for infectious disease specialists, supporting both providers and patients throughout the 
                  billing process. Our experienced team ensures accurate coding, timely claim submission, and effective <b>healthcare denial management</b>, 
                  helping your practice reduce delays and boost revenue. As a trusted 
                   <a
                      href="https://acerhealth.com/services/medical-coding-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
            medical coding and billing company,
                    </a>, we handle complex billing scenarios
                   involving long-term treatments, hospital visits, and follow-up care with full <b>medical billing compliance.</b> From insurance verification 
                   to documentation support, AcerHealth streamlines your <b>revenue cycle management,</b> minimizes administrative stress, and ensures smooth cash flow—so
                    you can stay focused on patient care.
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow9}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal9}
                      onClose={handleCloseModal9}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5 p-4">
              <div className="row">
                <div id="Gynecology" class="col-md-8 " style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Gynecology
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                   At AcerHealth, we provide specialized <b>medical billing services </b>for gynecology practices, ensuring accuracy, efficiency, and compliance.
                    Our experienced billing team understands the unique coding requirements for gynecological procedures, from routine exams to advanced 
                    treatments. As a trusted <b>medical coding and billing company,</b> we streamline your 
                    <a
                      href="https://acerhealth.com/services/revenue-cycle-management"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
          revenue cycle management 
                    </a>and help reduce denials and delays.    </p>
                     <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >
                   Our services include eligibility verification, timely claim submissions, and complete <b>healthcare denial management,</b>
                    allowing your practice to maintain a healthy cash flow. With a focus on precision and support, AcerHealth enables
                     gynecology providers to deliver better patient care without billing stress.    </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow10}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal10}
                      onClose={handleCloseModal10}
                    />
                  </span>
                </div>
                <div class="col-md-4 text-center mt-4">
                  <img
                    src={gynacology}
                    alt="gynacology"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-5">
              <div className="row">
                <div class="col-md-4 text-center ">
                  <img
                    src={Urology}
                    alt="Urology"
                    className="img-fluid"
                    width={350}
                    height={250}
                  />
                </div>
                <div id="Urology" class="col-md-8" style={{ marginTop: "20px" }}>
                  <h2
                    className="title AcerhealthTextPurple text-center"
                    style={{
                      fontSize: "30px",
                      fontFamily: "Alegreya Sans",
                      fontWeight: "bold",
                    }}
                  >
                    Urology
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >

                    AcerHealth delivers expert <b>medical billing services </b>tailored for urology practices, helping providers streamline operations and boost revenue. 
                    Our team understands the complex coding and documentation requirements for urological procedures, ensuring accurate claims and faster
                     reimbursements. As a leading<b> medical coding and billing company,</b> we support end-to-end<b> revenue cycle management, </b>from insurance verification 
                     to payment posting and 
                      <a
                      href="https://acerhealth.com/services/denial-management-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
            healthcare denial management.
                    </a>
                 
                  </p>
                      <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{ fontFamily: "Alegreya Sans", fontWeight: '500', fontSize: '18px',textAlign:"justify" }}
                  >

                By reducing billing errors and handling preauthorization’s efficiently, AcerHealth helps urology providers improve financial performance while maintaining full 
                      <a
                      href="https://acerhealth.com/services/medical-billing-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
          medical billing compliance
                    </a>
                  Focus on patient care—we’ll handle the billing to drive your practice’s growth and profitability.
                  </p>
                  <span
                    style={{
                      display: "inline-block",
                      marginLeft: "5px",
                      paddingTop: "5px",
                    }}
                  >
                    <MDBBtn
                      onClick={toggleShow11}
                      style={{
                        color: "white",
                        marginBottom: "10px",
                        background: "#582C83",
                        fontWeight: "bold",
                      }}
                    >
                      Connect with our experts
                    </MDBBtn>
                    <ContactModal
                      show={basicModal11}
                      onClose={handleCloseModal11}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </MDBContainer>
    </>
  );
};
export default Medicalbillingsys;
